import { render, staticRenderFns } from "./IndicatorsHistorySearchResults.vue?vue&type=template&id=2a51b7f6&scoped=true&"
import script from "./IndicatorsHistorySearchResults.vue?vue&type=script&lang=js&"
export * from "./IndicatorsHistorySearchResults.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsHistorySearchResults.vue?vue&type=style&index=0&id=2a51b7f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51b7f6",
  null
  
)

export default component.exports